import { triggerLogin } from "authentication/actions";
import { StyledModalText, UIButton } from "common/components";
import { useDispatch } from "common/utilities/react-redux";
import { useTranslate } from "common/utilities/useTranslate";
import { ModalHeader } from "domains/modal/components/ModalHeader";

export const UnauthenticatedModal = () => {
  const dispatch = useDispatch();
  const translate = useTranslate();

  return (
    <>
      <ModalHeader title={translate("app.login.unauthenticated.title")} />
      <StyledModalText>{translate("app.login.unauthenticated.message")}</StyledModalText>
      <UIButton fullwidth onClick={() => dispatch(triggerLogin())} variant="filled">
        {translate("app.user.sign_in")}
      </UIButton>
    </>
  );
};
